<template>
	<div class="cart" v-loading="loading">
		<template v-if="cartList.length || invalidGoods.length">
			<nav>
				<li>
					<el-checkbox v-model="checkAll" @change="allElection"></el-checkbox>
				</li>
				<li>商品信息</li>
				<li>价格</li>
				<li>操作</li>
			</nav>
			<div class="list" v-for="(siteItem, siteIndex) in cartList" :key="siteIndex">
				<div class="item">
					<div class="head">
						<el-checkbox v-model="siteItem.checked" @change="siteAllElection(siteIndex)"></el-checkbox>
						<router-link to="/shop" target="_blank">{{ siteItem.siteName }}</router-link>
						<el-tag size="small" v-if="siteItem.cartList[0].is_own == 1">自营</el-tag>
					</div>
					<ul v-for="(item, cartIndex) in siteItem.cartList" :key="cartIndex">
						<li>
							<el-checkbox v-model="item.checked" @change="singleElection(siteIndex, cartIndex)"></el-checkbox>
						</li>
						<li class="goods-info-wrap" @click="$router.pushToTab({ path: '/sku-' + item.sku_id })">
							<div class="img-wrap"><img class="img-thumbnail" :src="$img(item.sku_image, { size: 'mid' })" @error="imageError(siteIndex, cartIndex)" /></div>
							<div class="info-wrap">
								<h5>{{ item.sku_name }}1</h5>
								<span>{{ item.keywords }}</span>
								<template v-if="item.sku_spec_format">
									<span v-for="(x, i) in item.sku_spec_format" :key="i">
										{{ x.spec_name }}：{{ x.spec_value_name }} {{ i < item.sku_spec_format.length - 1 ? '；' : '' }}
									</span>
								</template>
							</div>
						</li>
						<li>
							<span>￥{{ item.discount_price }}</span>
						</li>
						<li>
							<el-button type="text" @click="deleteCart(siteIndex, cartIndex)">删除</el-button>
						</li>
					</ul>
				</div>
			</div>

			<div class="lose-list" v-if="invalidGoods.length">
				<div class="head">
					失效商品
					<span class="ns-text-color">{{ invalidGoods.length }}</span>
					件
				</div>
				<ul v-for="(goodsItem, goodsIndex) in invalidGoods" :key="goodsIndex">
					<li>
						<el-tag size="small" type="info">失效</el-tag>
					</li>
					<li class="goods-info-wrap">
						<div class="img-wrap"><img class="img-thumbnail" :src="$img(goodsItem.sku_image, { size: 'mid' })" @error="imageErrorInvalid(goodsIndex)" /></div>
						<div class="info-wrap">
							<h5>{{ goodsItem.sku_name }}</h5>
							<template v-if="goodsItem.sku_spec_format">
								<span v-for="(x, i) in goodsItem.sku_spec_format" :key="i">
									{{ x.spec_name }}：{{ x.spec_value_name }} {{ i < goodsItem.sku_spec_format.length - 1 ? '；' : '' }}
								</span>
							</template>
						</div>
					</li>
					<li>
						<span>￥{{ goodsItem.discount_price }}</span>
					</li>
				</ul>
			</div>
			<footer>
				<el-checkbox v-model="checkAll" @change="allElection">全选</el-checkbox>
				<ul class="operation">
					<li>
						<el-button type="text" @click="deleteCartSelected">删除</el-button>
					</li>
					<li>
						<el-button type="text" @click="clearInvalidGoods" v-if="invalidGoods.length!=0">清除失效宝贝</el-button>
					</li>
				</ul>
				<div class="sum-wrap">
					<div class="selected-sum">
						<span>已选商品</span>
						<em class="total-count">{{ totalCount }}</em>
						<span>件</span>
					</div>
					<el-button type="success" v-if="totalCount != 0"  @click="settlement">生成方案</el-button>
					<el-button type="info" v-else disabled  @click="settlement">生成方案</el-button>
				</div>
			</footer>
		</template>
		<div class="empty-wrap" v-else-if="!loading && (!cartList.length || !invalidGoods.length)">
			<router-link to="/">您的方案库是空的，赶快去逛逛，挑选商品吧！</router-link>
		</div>
	</div>
</template>

<script>
	import cart from './plan';
	export default {
		name: 'cart',
		mixins: [cart]
	};
</script>
<style lang="scss" scoped>
	@import './plan.scss';
	
	.auth-container{width:100%;box-sizing:border-box;border-radius:6px;min-height:600px;position:relative;margin-bottom:40px}
	.auth-container .header{width:100%;background-color:#f8f9f9}
	.auth-container .tabs-class .el-tabs__header .is-active{color:#202230}
	.auth-container .tabs-class .el-tabs__header .el-tabs__item{color:#202230;font-weight:700}
	.auth-container .tabs-class  .el-tabs__header .el-tabs__active-bar{background-color:#e7390c}
	.content-container{width:900px;margin:0 auto;background-size:100% 100%;box-sizing:border-box;padding:80px}
	.content-container .contract-container{width:100%;position:relative;padding-bottom:30px;box-sizing:border-box;background:transparent}
	.content-container .contract-container .title{font-size:20px;font-weight:700;text-align:center;margin-bottom:60px}
	.content-container .contract-container .top-info{width:100%;margin-bottom:40px}
	.content-container .contract-container .top-info .info-item{width:100%;margin-bottom:14px}
	.content-container .contract-container .top-info .info-item .key{margin-right:14px}
	.content-container .contract-container .top-info .info-item .value{display:inline-block;min-width:100px;line-height:1.5;border-bottom:1px solid #000}
	.content-container .contract-container .content{width:100%}
	.content-container .contract-container .content .content-item{width:100%;line-height:1.6;margin-bottom:8px;text-indent:2em}
	.content-container .contract-container .content .content-item span{padding:0 8px;margin:0 4px;box-sizing:border-box;display:inline;min-width:100px;border-bottom:1px solid #000}
	.content-container .contract-container .bottom{width:100%;text-align:right;position:relative;margin-top:50px;z-index:9}
	.content-container .contract-container .bottom .bottom-info{width:100%;margin-bottom:30px}
	.content-container .contract-container .bottom .bottom-info .value{text-decoration:underline}
	.content-container .contract-container .bottom .sign{position:absolute;right:320px;top:24px}
	.content-container .contract-container .logo{position:absolute;right:50px;bottom:0}
	.content-container .contract-container .logo img{width:200px;display:block}
	.no-auth{width:100%;text-align:center;font-size:18px;color:#999;margin-top:100px}
	.dialog-footer{width:100%;margin-top:20px;display:flex;align-items:center;justify-content:center}
	.dialog-footer .btn{width:120px;height:40px;border-radius:6px;font-size:15px;color:#666;display:flex;align-items:center;justify-content:center;cursor:pointer}
	.dialog-footer .cancel{border:1px solid #E2E2E2;margin-right:20px}
	.dialog-footer .submit{background:#e7390c;color:#fff;margin-right:20px}
</style>
